/* eslint-disable react/no-unstable-nested-components */
/* this linter is causing false positives in this file because of how the tag
 * replacers are being created. Hopefully the problem will go away when we get
 * away from super old react-intl
 */
import React from "react";

import { type VerificationService, type Locale } from "../../lib/types/types";
import { getLocaleSafely } from "../../lib/intl/intl";
import { setViewModel } from "../../lib/VerificationService/ViewModel";

import { FooterText } from "./FooterTextComponent";

export interface FormFooterProps {
  verificationService: VerificationService;
  children?: React.ReactNode;
  showShield?: boolean;
}

const FormFooterComponent = ({
  verificationService,
  children,
  showShield = false,
}: FormFooterProps) => {
  const { viewModel } = verificationService;
  const locale: Locale = getLocaleSafely(viewModel);
  const privacyPolicyRef = React.useRef<any>({});
  const cleanupCommonTags =
    /(<div[^>]+>|<div>|<\/div>)|(<span[^>]+>|<span>|<\/span>)|(<p[^>]+>|<p>|<\/p>)/gm;

  // Store the footer message that the user was shown when the user submitted
  React.useEffect(() => {
    if (!privacyPolicyRef.current) {
      return;
    }
    const privacyPolicyText = privacyPolicyRef.current.innerHTML.replace(cleanupCommonTags, "");
    const updatedViewModel = { metadata: { submissionOptIn: privacyPolicyText } };
    setViewModel(updatedViewModel);
  }, [privacyPolicyRef, locale]);

  return (
    <div className="sid-footer sid-h-small-text sid-l-space-top-md" role="contentinfo">
      {(showShield || !children) && (
        <div className="sid-footer__shield">
          <img
            alt=""
            src="https://assets-resources.sheerid.com/common/images/2018/icons/shield-check.svg"
          />
        </div>
      )}
      <div>
        <div className="sid-footer__one" ref={privacyPolicyRef}>
          {children || <FooterText verificationService={verificationService} />}
        </div>
      </div>
    </div>
  );
};

export { FormFooterComponent };
